// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"icon-wrapper__1-Q_R","numeric-badge":"numeric-badge__3QLJ5"};